import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import {Page} from 'b302-frontend-library';

import ExploreImage from '../../../assets/images/illustratie_explore.svg';
import UniversitySlider from '../../utils/UniversitySlider/UniversitySlider';
import ExploreModel from '../../../networking/models/ExploreModel';
import PageCard from '../../layout/PageCard';
import ExploreRepository from "../../../networking/repos/ExploreRepository"
import { ReactComponent as ChevronRight } from '../../../assets/icons/icon_chevron_right.svg';
import { ReactComponent as ChevronLeft } from '../../../assets/icons/icon_chevron_left.svg';
import ContactIllustration from '../../../assets/images/illustratie_contact_old_student.svg'
import HanCircle from '../../utils/UniversitySlider/HanCircle';
import HanButton from '../../utils/HanButton';
import LoadingIcon from '../../utils/LoadingIcon';
import Breadcrumbs from '../../utils/Breadcrumbs';

interface Props {}

const Explore: FunctionComponent<Props> = () => {

    const [[currentIndex, swipeDirection], setCurrentIndex] = useState<number[]>([0, 1]);

    const next = () => setCurrentIndex([currentIndex + 1, 1]);
    const previous = () => setCurrentIndex([currentIndex - 1, -1]);

    const [universities, setUniversities] = useState<ExploreModel[]>([])

    const [exploreRepo] = [
        new ExploreRepository()
    ];

    const getUniversities = useCallback(async () => {
        const uni = await exploreRepo.all()
        setUniversities(uni);
    }, [setUniversities]);

    useEffect(() => {
        getUniversities();
    }, [getUniversities]);

    if (universities.length === 0) {
        return <div className='explore__loading'><LoadingIcon/></div>
    }

    return (
        <Page className="explore">

            <img className="explore__image" src={ExploreImage} alt="explore"/>

            <div className="explore__top-section">

                <div className="explore__top-section__left">
                    <h1 className="explore__top-section__title">Explore</h1>
                    <div className="explore__top-section__circles">
                        {universities.map((university, i) => (
                            <HanCircle key={university.id} current={currentIndex === i ? "circle current" : "circle"}/>
                        ))}
                    </div>
                </div>

                <div className="explore__top-section__right">
                    <HanButton onClick={getUniversities}>
                        Refresh list
                    </HanButton>

                    <HanButton onClick={previous} disabled={currentIndex === 0}>
                        <div className="explore__top-section__button"><ChevronLeft className="explore__top-section__chevron"/></div>
                    </HanButton>

                    <HanButton onClick={next} disabled={currentIndex === universities.length - 1}>
                        <div className="explore__top-section__button"><ChevronRight className="explore__top-section__chevron"/></div>
                    </HanButton>
                </div>

            </div>
            <div className='explore__breadcrumbs'>
                <Breadcrumbs
                    breadcrumbs={
                        [
                            { name: "Home", url: "/" },
                            { name: "Explore", url: "/explore" }
                        ]
                    }
                />
            </div>

            <hr className="explore__top-section__line"/>
            
            <UniversitySlider
                universities={universities}
                currentIndex={currentIndex}
                direction={swipeDirection}
                next={next}
                previous={previous} />

            <h1 className="explore__info-header">More Information?</h1>

            <div className="explore__pagecard">
                <PageCard image={ContactIllustration} imageAlt={'Contact student'} text={'Contact student'} link={'/universities/' + universities[currentIndex].id + '/contact'}/>
            </div>
        </Page>
    );
};

export default Explore;
